export default "__VITE_ASSET__cdc69093__"